module.exports = __webpack_public_path__ + "img/hanting.a9f5a61d.jpg";